export default __webpack_public_path__ + "static/media/Loader.3da374a4.svg";